// const baseURL = 'https://storage.googleapis.com/prismage.appspot.com';
const baseURL = 'https://pub-9e4df523bd724b0f878835b78e0f3cdf.r2.dev';

export function getUrl(url: string) {
  return `${baseURL}/${url}`;
}

export function OpenSocialLink(target, social) {
  if (!target) {
    return;
  }
  let url = "";
  if (!target[social]) {
    return;
  }
  url = target[social];

  if (url.includes("http")) {
    window.open(url, "_blank");
  } else if (social !== "website") {
    window.open(`https://${social}.com/${url}`, "_blank");
  } else {
    window.open(`https://${url}`, "_blank");
  }
}
